export default __webpack_public_path__ + "static/stamp-dark-3cfaaa91ba30727ddf469111adde4e91.svg";